import actions from "../../actions";

export default {
  [actions.file.created]: (payload) => {
    window.open(payload);
  },
};
